import React, { Component } from 'react';
import {Button, Row, Col} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import API from '../../../../services/API';
import Form from './components/Form';
import Table from './components/Table';
import FieldGroup from "../../../../components/FieldGroup";

class Affid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            affidValues: [],
            cutoffs: [],
            showForm: false,
            cutoffToUpdate: null,
            search: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    componentDidMount() {
        this.loadAffidValues();
        this.load();
    }

    load() {
        this.props.setLoading('AFFID');
        API.PcCutoff.getAffid().then(({ cutoffs }) => {
            this.setState({ cutoffs });
            this.props.setLoaded('AFFID');
        });
    }

    loadAffidValues() {
        API.TrackerAffids.get('pc').then(affids => this.setState({ affidValues: affids }))
    }

    handleSubmit({ update, id, ...cutoff }) {
        this.setState({ showForm: false, cutoffToUpdate: null });
        this.props.setLoading('AFFID_SAVE');

        const promise = update ? API.PcCutoff.updateAffid(id, cutoff) : API.PcCutoff.saveAffid(cutoff);

        promise.then(() => {
            this.props.setLoaded('AFFID_SAVE');
            this.load();
        })
    }

    handleFormHide() {
        this.setState({ showForm: false, cutoffToUpdate: null });
    }

    handleAddBtnClick() {
        this.setState({ showForm: true });
    }

    handleUpdate(cutoff) {
        this.setState({ showForm: true, cutoffToUpdate: cutoff });
    }

    handleRemove(id) {
        this.props.setLoading('AFFID_REMOVE');

        API.PcCutoff.deleteAffid(id).then(() => {
            this.props.setLoaded('AFFID_REMOVE');
            this.load();
        })
    }

    getForm() {
        if(this.state.showForm)
            return <Form cutoff={this.state.cutoffToUpdate} affidValues={this.state.affidValues} onSubmit={this.handleSubmit} onFormHide={this.handleFormHide}/>;
    }

    render() {
        let { cutoffs, search } = this.state;

        if(search) cutoffs = cutoffs.filter(cutoff => cutoff.affids.match(search));

        return (
            <div>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle={'success'} onClick={this.handleAddBtnClick}>Add</Button>
                        </div>
                    </Col>
                </Row>

                {this.getForm()}

                <div>
                    <FieldGroup name="search" label="Search:" onChange={this.handleFieldChange} value={this.state.search} />
                </div>
                <Table cutoffs={cutoffs} onUpdate={this.handleUpdate} onRemove={this.handleRemove}/>
            </div>
        );
    }
}

export default Affid;


// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/Affid/index.js